import { calcTaxAmt } from "../../../objects/AssetsExpenses/taxAmtCalc_function";

export const calculateRetirementTransferTax = (transferAmt, transferFee, assetTable, 
        gameDate, taxTranNbr) => {
   
    const regularTaxRate = +calcTaxAmt(assetTable, "regular", "TaxRate");
    const totalTransferPenalty = (.10 * transferAmt) +
        (+regularTaxRate * transferAmt);
    if (totalTransferPenalty > +transferFee){
        const transferTaxAmt = ((totalTransferPenalty - +transferFee) * -1).toString();
        const taxTransaction = {tranType: "regularTax", tranAmount: transferTaxAmt, tranNbr: taxTranNbr.toString(),
            taxRate: regularTaxRate.toString(), transferAmt: transferAmt.toString(), tranDate: gameDate,
            taxLongText: "Federal Income Tax - Transfer"};
        const returnObj={taxAmt: transferTaxAmt, taxTran: taxTransaction, taxRate: regularTaxRate,
            tranNbr: taxTranNbr
        }
        return returnObj;
    }
}
export default calculateRetirementTransferTax;